import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LogoWhite from '../../../assets/images/logos/white-bg-logo-hiacuity.png';
import { COMMON_KEYS, NS } from '../../../i18n/constants/keys';
import { getImageSrc } from '../../../utils/helpers/image-utils';

export interface INavBarLogoProps {
  isJobPosting: boolean;
  companyLogo: string | null;
}

export const NavBarLogo = ({
  isJobPosting,
  companyLogo,
}: INavBarLogoProps) => {
  const { t } = useTranslation(NS.common);

  return (
    <Link
      to={isJobPosting ? '/jobs' : '/'}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        minWidth: 0,
      }}
    >
      <Box
        component='img'
        src={getImageSrc(companyLogo, LogoWhite)}
        alt={t(COMMON_KEYS.navbar.companyLogoAlt)}
        sx={{
          maxHeight: { xs: 32, sm: 38, lg: 42 },
          maxWidth: { xs: 130, sm: 180, md: 240 },
          width: 'auto',
          objectFit: 'contain',
          transition: 'opacity 0.2s ease',
          '&:hover': {
            opacity: 0.9,
          },
        }}
      />
    </Link>
  );
};
